/**
 * Project panel
 *
 * Created by stefensuhat on 11/08/18 10.48 AM
 */

import { api } from 'utils/index';

const defaultState = {
    saved: false,
    errors: null,
};

export default {
    name: 'refund',
    state: defaultState,
    reducers: {
        reset: state => ({ ...state, ...defaultState }),
        saveResponse: (state, payload) => {
            if (payload.errors) {
                return ({ ...state, errors: payload.errors });
            }
            return ({ ...state, saved: true });
        },
    },
    effects: {
        async save(data) {
            await api.post('refunds', data)
                .then(response => this.saveResponse(response));
        },
    },
};
